import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useRequestCallSetup } from '../hooks/useRequestCallSetup';
import './RequestCallSetupModal.css';

const RequestCallSetupModal = ({ isOpen, onClose, packageData, isSalesPartnerRequest = false }) => {
  const { user, userData } = useAuth();
  const headerTitle = isSalesPartnerRequest ? 'Sales Partner Request Call Form' : 'Request Call Setup';
  const headerSubtitle = isSalesPartnerRequest ? "Fill in the details below and we'll get back to you" : "Fill in the details below and we'll get back to you";
  const headerClass = isSalesPartnerRequest ? 'request-call-modal-header request-call-modal-header--sales-partner' : 'request-call-modal-header';
  const headerClassCompact = isSalesPartnerRequest ? 'request-call-modal-header request-call-modal-header--compact request-call-modal-header--sales-partner' : 'request-call-modal-header request-call-modal-header--compact';
  const {
    formData,
    handleChange,
    handleSubmit,
    alreadySubmitted,
    hasExistingRequestInDb,
    loadingRequestCheck,
    isSubmitting,
    showSuccessModal,
    setShowSuccessModal,
    showErrorModal,
    setShowErrorModal,
    errorMessage,
    setErrorMessage
  } = useRequestCallSetup({ isOpen, user, userData, packageData, isSalesPartnerRequest });

  if (!isOpen) return null;

  // Loading check for existing request
  if (loadingRequestCheck && user?.uid) {
    return (
      <div className="request-call-modal-overlay" onClick={onClose}>
        <div className="request-call-modal-content request-call-modal-content--compact" onClick={(e) => e.stopPropagation()}>
          <div className={headerClassCompact}>
            <div className="modal-header-content">
              <div className="modal-header-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <h2>{headerTitle}</h2>
            </div>
            <button className="request-call-modal-close" onClick={onClose} aria-label="Close modal">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div className="request-call-already-received">
            <div className="request-call-loading-spinner" aria-hidden="true"></div>
            <p className="request-call-already-received-message">Checking...</p>
          </div>
        </div>
      </div>
    );
  }

  // Already submitted or request exists in DB: show message only, no form
  const showAlreadyReceived = alreadySubmitted || hasExistingRequestInDb;
  if (showAlreadyReceived) {
    return (
      <div className="request-call-modal-overlay" onClick={onClose}>
        <div className="request-call-modal-content request-call-modal-content--compact" onClick={(e) => e.stopPropagation()}>
          <div className={headerClassCompact}>
            <div className="modal-header-content">
              <div className="modal-header-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <h2>{headerTitle}</h2>
            </div>
            <button className="request-call-modal-close" onClick={onClose} aria-label="Close modal">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div className="request-call-already-received">
            <p className="request-call-already-received-title">We have already received your request.</p>
            <p className="request-call-already-received-message">Our Sales Team will contact you shortly via Phone and email.</p>
            <button type="button" className="btn-submit btn-close-received" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="request-call-modal-overlay" onClick={onClose}>
        <div className="request-call-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className={headerClass}>
            <div className="modal-header-content">
              <div className="modal-header-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <div>
                <h2>{headerTitle}</h2>
                <p className="modal-header-subtitle">{headerSubtitle}</p>
              </div>
            </div>
            <button className="request-call-modal-close" onClick={onClose} aria-label="Close modal">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          <form onSubmit={handleSubmit} className="request-call-form">
            <div className="form-section">
              <div className="form-section-title">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                <span>Personal Information</span>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">
                    <span>Name</span>
                    <span className="required-asterisk">*</span>
                  </label>
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      disabled
                      className="form-input form-input--no-icon"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="email">
                    <span>Email</span>
                    <span className="required-asterisk">*</span>
                  </label>
                  <div className="input-wrapper">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      disabled
                      className="form-input form-input--no-icon"
                    />
                  </div>
                </div>

              </div>
            </div>

            <div className="form-section">
              <div className="form-section-title">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <span>Contact Details</span>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="mobile">
                    <span>Mobile</span>
                    <span className="required-asterisk">*</span>
                  </label>
                  <div className="input-wrapper">
                    <input
                      type="tel"
                      id="mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                      placeholder="10-digit mobile number"
                      className="form-input form-input--no-icon"
                      pattern="[0-9]{10}"
                      maxLength="10"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="alternateMobile">
                    <span>Alternate Mobile Number</span>
                  </label>
                  <div className="input-wrapper">
                    <input
                      type="tel"
                      id="alternateMobile"
                      name="alternateMobile"
                      value={formData.alternateMobile}
                      onChange={handleChange}
                      placeholder="Optional"
                      className="form-input form-input--no-icon"
                      pattern="[0-9]{10}"
                      maxLength="10"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-section">
              <div className="form-section-title">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
                <span>Package / interest</span>
              </div>
              <div className="form-row">
                <div className="form-group form-group--full">
                  <label htmlFor="interestedPackage">
                    <span>Which package are you interested in?</span>
                  </label>
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="interestedPackage"
                      name="interestedPackage"
                      value={formData.interestedPackage || ''}
                      readOnly
                      disabled
                      className="form-input form-input--no-icon"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button type="button" onClick={onClose} className="btn-cancel">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
                Cancel
              </button>
              <button type="submit" className="btn-submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <svg className="spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
                    </svg>
                    Submitting...
                  </>
                ) : (
                  <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    Submit Request
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="success-modal-overlay">
          <div className="success-modal-content">
            <div className="success-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <h2>Thank You!</h2>
            <p>We have received your request. Our Sales Team will contact you shortly via Phone and email.</p>
            <button 
              className="btn-close-success" 
              onClick={() => {
                setShowSuccessModal(false);
                onClose();
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Error Modal */}
      {showErrorModal && (
        <div className="error-modal-overlay">
          <div className="error-modal-content">
            <div className="error-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </div>
            <h2>Oops! Something Went Wrong</h2>
            <p>{errorMessage || 'Failed to submit request. Please try again.'}</p>
            <button 
              className="btn-close-error" 
              onClick={() => {
                setShowErrorModal(false);
                setErrorMessage('');
              }}
            >
              Try Again
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default RequestCallSetupModal;
